"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createBeaconReporter;

var _querystring = _interopRequireDefault(require("querystring"));

/**
 * Sends a beacon with `navigator.sendBeacon`.
 *
 * NOTE: Due to security concerns, some browsers have updated their
 * implementation to throw when `navigator.sendBeacon` is called with a blob
 * whose type is not any of the CORS-safelisted values for the `Content-Type`
 * request header.
 *
 * @see https://bugs.chromium.org/p/chromium/issues/detail?id=490015
 *
 * CAUTION: `navigator.sendBeacon` appears to be unreliable when called before
 * the page is unloaded.
 *
 * @see https://volument.com/blog/sendbeacon-is-broken
 */
function postBeaconWithNavigator(url, data) {
  try {
    var blob = new Blob([data], {
      type: 'application/x-www-form-urlencoded'
    });
    return navigator.sendBeacon(url, blob);
  } catch (error) {
    return false;
  }
}
/**
 * Send a beacon using XMLHttpRequest
 */


function postBeaconWithXhr(url, data) {
  try {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', url);
    xhr.setRequestHeader('content-type', 'application/x-www-form-urlencoded');
    xhr.send(data);
    return true;
  } catch (error) {
    return false;
  }
}
/**
 * Creates a reporter that sends beacon data via the Navigator Beacon API or
 * XMLHttpRequest. The reporter checks if a beacon URL has been configured and
 * if there are any beacon variables queued to be sent. If both are true,
 * it fires the beacon.
 */


function createBeaconReporter(options) {
  return function beaconReporter(variables) {
    var url = options.url;

    var encoded = _querystring.default.stringify(variables);

    if (url == null) {
      return false;
    }

    if (!encoded.length) {
      return false;
    }

    return postBeaconWithNavigator(url, encoded) || postBeaconWithXhr(url, encoded);
  };
}